(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@bingads-webui-universal/primitive-utilities"));
	else if(typeof define === 'function' && define.amd)
		define(["@bingads-webui-universal/primitive-utilities"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("@bingads-webui-universal/primitive-utilities")) : factory(root["@bingads-webui-universal/primitive-utilities"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__8__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 178);
/******/ })
/************************************************************************/
/******/ ({

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(179);


/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "getLocalStorage", {
  enumerable: true,
  get: function get() {
    return _localStorage.default;
  }
});
Object.defineProperty(exports, "getMemoryStorage", {
  enumerable: true,
  get: function get() {
    return _memoryStorage.default;
  }
});
Object.defineProperty(exports, "getSessionStorage", {
  enumerable: true,
  get: function get() {
    return _sessionStorage.default;
  }
});

var _localStorage = _interopRequireDefault(__webpack_require__(180));

var _memoryStorage = _interopRequireDefault(__webpack_require__(181));

var _sessionStorage = _interopRequireDefault(__webpack_require__(182));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default(instrumentation) {
  const logError = function logError(error) {
    if (instrumentation && instrumentation.logError) {
      instrumentation.logError(error.message);
    } else {
      console.error(error.message); // eslint-disable-line no-console
    }
  };

  const LocalStorage = {
    supportsStorage() {
      try {
        return window && 'localStorage' in window && window.localStorage != null;
      } catch (err) {
        logError(err);
        return false;
      }
    },

    set(key, data) {
      const str = JSON.stringify(data);

      try {
        window.localStorage.setItem(key, str);
      } catch (err) {
        try {
          window.localStorage.clear();
          window.localStorage.setItem(key, str);
        } catch (innerErr) {
          logError(innerErr);
        }
      }
    },

    get(key) {
      let result = null;

      try {
        const str = window.localStorage.getItem(key);

        if (str) {
          result = JSON.parse(str);
        }
      } catch (err) {
        logError(err);
      }

      return result;
    },

    invalidate(key) {
      try {
        window.localStorage.removeItem(key);
      } catch (err) {
        logError(err);
      }
    },

    clear() {
      try {
        window.localStorage.clear();
      } catch (err) {
        logError(err);
      }
    },

    keys() {
      return Object.getOwnPropertyNames(window.localStorage);
    },

    type: 'localStorage'
  };
  return LocalStorage;
}

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _primitiveUtilities = __webpack_require__(8);

function _default() {
  let dataset = {};
  const MemoryStorage = {
    supportsStorage() {
      return true;
    },

    set(key, data) {
      dataset[key] = data;
    },

    get(key, deepCopy) {
      let result = null;

      if (Object.prototype.hasOwnProperty.call(dataset, key)) {
        result = dataset[key];
      }

      if (result && deepCopy) {
        result = (0, _primitiveUtilities.cloneDeep)(result);
      }

      return result;
    },

    invalidate(key) {
      if (Object.prototype.hasOwnProperty.call(dataset, key)) {
        delete dataset[key];
      }
    },

    clear() {
      dataset = {};
    },

    keys() {
      return Object.getOwnPropertyNames(dataset);
    },

    type: 'memoryStorage'
  };
  return MemoryStorage;
}

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default(instrumentation) {
  const logError = function logError(error) {
    if (instrumentation && instrumentation.logError) {
      instrumentation.logError(error.message);
    } else {
      console.error(error.message); // eslint-disable-line no-console
    }
  };

  const SessionStorage = {
    supportsStorage() {
      return window && 'sessionStorage' in window && window.sessionStorage != null;
    },

    set(key, data) {
      const str = JSON.stringify(data);

      try {
        window.sessionStorage.setItem(key, str);
      } catch (err) {
        try {
          window.sessionStorage.clear();
          window.sessionStorage.setItem(key, str);
        } catch (innerErr) {
          logError(err);
        }
      }
    },

    get(key) {
      let result = null;

      try {
        const str = window.sessionStorage.getItem(key);

        if (str) {
          result = JSON.parse(str);
        }
      } catch (err) {
        logError(err);
      }

      return result;
    },

    clear() {
      try {
        window.sessionStorage.clear();
      } catch (err) {
        logError(err);
      }
    },

    invalidate(key) {
      try {
        window.sessionStorage.removeItem(key);
      } catch (err) {
        logError(err);
      }
    },

    type: 'sessionStorage'
  };
  return SessionStorage;
}

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8__;

/***/ })

/******/ });
});
